"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function ComingSoon() {
  return <section data-section-id="116863" id="systematic-trading-simplified" className="dark bg-background text-foreground min-h-[70vh] flex flex-col items-center justify-center relative px-4 py-24 overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-5xl mx-auto flex flex-col items-center z-10 w-full">
        
        {}
        <div className="flex items-center gap-4 mb-10">
          <Badge variant="outline" className="border-primary text-primary rounded-none px-4 py-1.5 font-sans tracking-[0.5em] text-[9px] uppercase bg-transparent">
            PLAN · ACT · LEARN
          </Badge>
          <span className="text-[9px] font-sans tracking-[0.4em] text-foreground/30 uppercase flex items-center gap-2">
            <span className="w-8 h-px bg-border block" />
            MARKET PRECISION
            <span className="w-8 h-px bg-border block" />
          </span>
        </div>

        {}
        <h1 className="font-sans text-4xl md:text-5xl lg:text-[76px] leading-tight text-center mb-8 text-foreground font-medium tracking-tight">
          Seven Minutes. All Week.
        </h1>

        {}
        <p className="font-serif text-lg md:text-[21px] italic text-foreground/60 max-w-[560px] text-center mb-16 leading-relaxed">
          A systematic framework for the modern trader. Designed for precision, defined risk, and capital preservation in every market move.
        </p>

        {}
        <div className="mt-8 md:mt-12">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-[#D4AE52] font-sans tracking-widest rounded-none px-10 h-16 text-base shadow-none transition-all duration-300 hover:-translate-y-0.5">
            <Link to="/ThePlannerPage">
              Start Your Plan
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}